import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import WidgetHostConfigsApi from '../generated/api/WidgetHostConfigs';

export default (service: Servicelayer) => ({
  ...WidgetHostConfigsApi(service),

  // Add custom calls here

});
